import script from "./UserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserModal.vue?vue&type=script&setup=true&lang=js"

import "./UserModal.vue?vue&type=style&index=0&id=986f3e38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-986f3e38"]])

export default __exports__